var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1101 27.0226H12.542V23.6508H16.1101V27.0226ZM13.3094 26.2974H15.3426V24.376H13.3094V26.2974Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6217 27.0226H24.0539V23.6508H27.6217V27.0226ZM24.8213 26.2974H26.8543V24.376H24.8213V26.2974V26.2974Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0311 13.9676H12.4632V10.5957H16.0313V13.9676H16.0311ZM13.2307 13.2423H15.2639V11.321H13.2307V13.2423Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6357 13.9676H17.0679V10.5957H20.636V13.9676H20.6357ZM17.8353 13.2423H19.8685V11.321H17.8353V13.2423Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0311 18.3194H12.4632V14.9473H16.0313V18.3194H16.0311ZM13.2307 17.5942H15.2639V15.6728H13.2307V17.5942Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6357 18.3194H17.0679V14.9473H20.636V18.3194H20.6357ZM17.8353 17.5942H19.8685V15.6728H17.8353V17.5942Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0311 22.671H12.4632V19.2989H16.0313V22.671H16.0311ZM13.2307 21.9458H15.2639V20.0244H13.2307V21.9458Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6357 22.671H17.0679V19.2989H20.636V22.671H20.6357ZM17.8353 21.9458H19.8685V20.0244H17.8353V21.9458Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5427 18.3194H23.9748V14.9473H27.5427V18.3194ZM24.7423 17.5942H26.7752V15.6728H24.7423V17.5942Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5427 22.671H23.9748V19.2989H27.5427V22.671ZM24.7423 21.9458H26.7752V20.0244H24.7423V21.9458Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5846 30.2747V13.2423H22.6945V9H10.4154V30.2747H9V31H17.1467H20.7147H31V30.2747H29.5846ZM28.8171 13.9676V30.2747H22.6945V13.9676H28.8171ZM17.9141 30.2747V24.376H19.9473V30.2747H17.9141ZM17.1467 23.6508V30.2747H11.1829V9.72527H21.927V30.2747H20.7147V23.6508H17.1467Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/building-icon.592f93fbe5635dc988ca21345c54e4e6.svg";
export { ForwardRef as ReactComponent };